export default "__VITE_ASSET__csvz2Svw__"